import styled from '@emotion/styled';
import { TransitionGroup } from 'react-transition-group';

import _NextIcon from '@/assets/icons/icon_next_gray.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const DateSelector = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: [
      '84px 1fr 84px',
      '84px 1fr 84px',
      '105px 170px 105px',
      '105px 170px 105px',
    ],
    gridGap: [0, 0, '0 60px', '0 60px'],
    width: ['100%', '100%', '500px', '500px'],
    justifyContent: 'center',
    margin: `${defaultTheme.spacing.xxl} auto`,
  }),
);

export const CurrentRaceHeadLine = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    fontSize: defaultTheme.font.size.m,
    fontWeight: 'bold',
    textAlign: 'center',
    '& > h2': {
      fontSize: [
        defaultTheme.font.size.m,
        defaultTheme.font.size.xl,
        defaultTheme.font.size.xxl,
        defaultTheme.font.size.xxl,
      ],
      marginBottom: defaultTheme.spacing.l,
    },
    '& > time': {
      fontSize: [
        defaultTheme.font.size.s,
        defaultTheme.font.size.m,
        defaultTheme.font.size.m,
        defaultTheme.font.size.m,
      ],
    },
  }),
);

export const RaceList = styled(TransitionGroup)(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: [
      'repeat(1, 1fr)',
      'repeat(1, 1fr)',
      'repeat(2, 1fr)',
      'repeat(2, 1fr)',
    ],
    gridGap: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
    ],
    justifyContent: 'left',
    width: '100%',
  }),
).withComponent('ul');

export const ButtonTextWrapper = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
);

export const NextIcon = styled.i(() =>
  mq({
    display: 'block',
    width: '9px',
    height: '16px',
    backgroundImage: `url(${_NextIcon})`,
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    margin: [
      defaultTheme.spacing.xs,
      defaultTheme.spacing.xs,
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
    ],
  }),
);

export const PrevIcon = styled(NextIcon)(() =>
  mq({
    transform: 'rotate(-180deg)',
  }),
);

export const RaceEmptyMessage = styled.p(() =>
  mq({
    color: defaultTheme.text.gray,
    fontSize: defaultTheme.font.size.m,
    textAlign: 'center',
    padding: '80px 0',
  }),
);

export const EmptyMessage = styled.p(() =>
  mq({
    color: defaultTheme.text.gray,
    fontSize: [
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
      defaultTheme.font.size.m,
    ],
    textAlign: 'center',
    padding: '30px 0',
  }),
);

export const GoodWinStreakTitle = styled.p(() =>
  mq({
    textAlign: 'center',
    marginTop: defaultTheme.spacing.xl,
    paddingTop: defaultTheme.spacing.s,
    paddingBottom: defaultTheme.spacing.xl,
    fontSize: [
      defaultTheme.font.size.xl,
      defaultTheme.font.size.xl,
      defaultTheme.font.size.xl,
      defaultTheme.font.size.xxl,
    ],
  }),
);

export const GoodWinAvgTitle = styled.p(() =>
  mq({
    textAlign: 'center',
    marginTop: defaultTheme.spacing.xl,
    paddingTop: defaultTheme.spacing.s,
    paddingBottom: defaultTheme.spacing.xs,
    fontSize: [
      defaultTheme.font.size.xl,
      defaultTheme.font.size.xl,
      defaultTheme.font.size.xl,
      defaultTheme.font.size.xxl,
    ],
  }),
);

export const GoodWinAvgNote = styled.p(() =>
  mq({
    textAlign: 'center',
    fontSize: [
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
      defaultTheme.font.size.m,
    ],
    fontWeight: 'normal',
    paddingBottom: defaultTheme.spacing.xl,
  }),
);

export const TodayRacerList = styled.ul(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: '1frameElement',
    gap: '8px',
    '@media (min-width: 768px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '12px',
    },
    padding: 0,
  }),
);
